import styled from 'styled-components';

/* Mixins */
import {
  WebFontHeader2Bold,
  WebFontCallout1,
  WebFontCallout2,
  WebFontBody1,
  WebFontBody2,
  FlexDirectionColumn,
} from 'styles/Mixins';

/* Utils */
import { mediaQuery } from 'styles/Utils';

export const Wrapper = styled.div`
  ${FlexDirectionColumn};
  align-items: flex-start;
  width: 100%;
  color: ${({ theme }) => theme.Grey1};
`;

export const Title = styled.div`
  ${WebFontHeader2Bold};
`;

export const SubTitle = styled.div`
  line-height: 1.5;
  margin: 8px 0 24px;

  ${mediaQuery.mobile`
    ${WebFontBody2};
  `}
  ${mediaQuery.desktop`
    ${WebFontBody1};
  `}
`;

export const CollapsibleSectionWrapper = styled.div`
  width: 100%;
  padding: 8px 0;
  cursor: pointer;
  border-top: 1px solid ${({ theme }) => theme.palettesGrey400};

  :last-child {
    border-bottom: 1px solid ${({ theme }) => theme.palettesGrey400};
  }
`;

export const Question = styled.div`
  line-height: 1.5;

  ${mediaQuery.mobile`
    ${WebFontCallout2};
  `}
  ${mediaQuery.desktop`
    ${WebFontCallout1};
  `}
`;

export const Answer = styled.div`
  line-height: 1.5;

  ${mediaQuery.mobile`
    ${WebFontBody2};
  `}
  ${mediaQuery.desktop`
    ${WebFontBody1};
  `}
`;

export const Footnote = styled.div`
  ${WebFontBody2};
  margin-top: 16px;
`;
